import React, { useState } from "react";

const AssigneeSelector = ({
  assignees,
  selectedAssignees,
  setSelectedAssignees,
  creatorId,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const toggleAssignee = (assigneeId) => {
    if (assigneeId === creatorId) {
      return; // Prevent deselection of the creator
    }
    if (selectedAssignees.includes(assigneeId)) {
      setSelectedAssignees(selectedAssignees.filter((id) => id !== assigneeId));
    } else {
      setSelectedAssignees([...selectedAssignees, assigneeId]);
    }
  };

  // Filter assignees based on search term
  const filteredAssignees = assignees.filter((assignee) =>
    assignee.displayName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <input
        type="text"
        className="w-full p-2 border rounded-lg mb-4"
        placeholder="Search users..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {searchTerm && ( // Only render if there's a search term
        <div className="flex flex-wrap gap-4">
          {filteredAssignees.map((assignee) => {
            const isSelected = selectedAssignees.includes(assignee.id);
            return (
              <div
                key={assignee.id}
                className={`cursor-pointer p-2 border rounded-lg flex items-center gap-2 ${
                  isSelected ? "bg-blue-100 border-blue-500" : "border-gray-300"
                }`}
                onClick={() => toggleAssignee(assignee.id)}
              >
                <img
                  src={
                    assignee.profileImage || "https://via.placeholder.com/40"
                  }
                  alt={assignee.displayName}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <span>{assignee.displayName}</span>
                {assignee.id === creatorId && (
                  <span className="text-xs text-blue-500">(Creator)</span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AssigneeSelector;
